<template>
  <div id="app">
    <div class="navPcParent">
      <el-row class="navPc">
        <el-col :span="4" style="text-align:center;">
          <img :src="logosrc" alt height="50px" width="174px" style='margin:15px 0'/>
          <div></div>
        </el-col>
        <el-col :span="18" class="navRight" style="height:100%;">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#235e9d"
            text-color="#fff"
            @select="handleSelect"
            router
          >
          <el-menu-item index="1" route="/?value=0&id=0" class="animated rubberBand">首页</el-menu-item>
          <!-- <el-menu-item v-for='(item,index) in routeList3' :key="index"  :index="index + 2" :route="getRountNamePc(item.path,item.value) +'&id=0'" class="animated rubberBand">{{item.title}}</el-menu-item> -->
            <!-- <el-submenu 
              v-for='(item,index) in routeList3' 
              :key='item.title' 
              :index="index+2" 
              :route="getRountName(item.path,item.value)" 
              class="animated rubberBand">
              <template slot="title">{{item.title}}</template>
              <el-menu-item class="newsBack" :index="(index+2)+'-'+(b+1)" v-for="(a,b) in item.children" :key='b' :route="getRountNamePc(item.path,item.value)+'&id='+a.id" >{{a.title}}</el-menu-item>
            </el-submenu> -->
            
            <el-submenu 
              index="2" 
              :route="getRountName('/LaboratoryServices','165')"
              class="animated rubberBand">
              <template slot="title">实验室服务项目</template>
              <el-menu-item class="newsBack" :index="(2)+'-'+(b+1)" v-for="(a,b) in routeList3[0].children" :key='b' :route="getRountNamePc(routeList3[0].path,routeList3[0].value)+'&id='+a.id" >{{a.title}}</el-menu-item>
            </el-submenu>
            <!-- <el-menu-item index="3" :route="routeList3[1].path + '?value='+ routeList3[1].value +'&id=0'" class="animated rubberBand">竞争力分析</el-menu-item> -->
            <el-menu-item index="4" :route="routeList3[1].path + '?value='+ routeList3[1].value +'&id=0'" class="animated rubberBand">实验室建设</el-menu-item>
            <el-submenu 
              index="5" 
              :route="getRountName('/sale','197')"
              class="animated rubberBand">
              <template slot="title">设备销售</template>
              <el-menu-item class="newsBack" :index="(5)+'-'+(b+1)" v-for="(a,b) in routeList3[2].children" :key='b' :route="getRountNamePc(routeList3[2].path,routeList3[2].value)+'&id='+a.id" >{{a.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item index="6" :route="routeList3[3].path + '?value='+ routeList3[3].value +'&id=0'" class="animated rubberBand">维保支援</el-menu-item>
          <el-menu-item index="7" route="/news?value=02&id=0" class="animated rubberBand">新闻动态</el-menu-item>
          <!-- <el-menu-item index="8" route="/about?value=01&id=0" class="animated rubberBand">关于我们</el-menu-item> -->
            <el-submenu index="8" route="/about?value=01&id=0" class="animated rubberBand">
              <template slot="title">关于我们</template>
              <el-menu-item  class="newsBack" index="8-1" route="/about?value=01&id=1">公司介绍</el-menu-item>
              <el-menu-item  class="newsBack" index="8-2" route="/about?value=01&id=2">发展历程</el-menu-item>
            </el-submenu>
          </el-menu> 
        </el-col>
      </el-row>
    </div>
    <div class="navMobile">
      <div class="topTitle">
        {{titleNav}}
        <div
          style="position:absolute;height:50px;width:50px;right:10px;top:50%;margin-top:-25px;"
          @click="iconClick"
        >
          <i class="el-icon-s-unfold"></i>
        </div>
      </div>
      <!-- <ul class="navList" v-if="!ulDisable" @click="indexChange"> -->
      <!-- <ul class="navList" v-if="!ulDisable">
        <template  v-for="(item,index) in routeList">
          <li :key="index" v-if="item.children ? (item.children.length > 1 ? true : false) : false" class="firstLi" @click="isShowLi()">
            <router-link
              :to="getRountName(item.path,item.value)"
              :data-type="index+1"
              :data-title="item.title"
              class="animated rubberBand"
            >{{item.title}}</router-link>
             <ul class="childrenList" v-if="showLi">
              <li v-for="(item2,index2) in item.children" :key="index2">
                {{item2.title}}
              </li>
            </ul>
            <div class="imgIcon" > - </div>
          </li>
          <li :key="index" v-else class="firstLi">
            <router-link
              :to="getRountName(item.path,item.value)"
              :data-type="index+1"
              :data-title="item.title"
              class="animated rubberBand"
            >{{item.title}}</router-link>
            <div class="imgIcon" > > </div>
          </li>
        </template>
      </ul> -->
      <div v-if="!ulDisable" class="newNavList">
        <el-collapse v-model="mobileActiveName" accordion>
          <template  v-for="(item,index) in routeList">
            <el-collapse-item :key="index" :title="item.title" :name="index" v-if="item.children ? (item.children.length > 1 ? true : false) : false">
              <div v-for="(item2,index2) in item.children" :key="index2" @click="childrenGopage(item,item2,index)">
                {{item2.title}}
              </div>
            </el-collapse-item>
             <el-collapse-item :key="index" :title="item.title" disabled :name="index" v-else @click.native="mobileGoPage(item,item)">
               <div  @click="mobileGoPage()">aa</div>
            </el-collapse-item>
          </template>
        </el-collapse>
      </div>
    </div>
    <router-view />
    <div class="footMargin">
      <div class="foot" @click="getActiveIndex">
        <el-row class="footers">
          <el-col :span="12">
            <h5 style="font-size:16px;margin-bottom:4px;">总部</h5>
            <h5 style="margin-bottom:4px;margin-top:4px;">上海浦东实验室：上海市浦东新区张东路1388号2号楼</h5>
            <h5 style="margin-top:4px;">电话: 021-58372276</h5>
            <h5 style="margin-top:15px;margin-bottom:4px;">上海浦西实验室：上海市徐汇区钦江路333号钦江园37号楼1F</h5>
            <h5 style="margin-top:4px;">电话: 021-54661507</h5>
            <h5 style="margin-bottom:4px;">北京实验室：北京市海淀区上地七街国际创业园金远见大厦一楼</h5>
            <h5 style="margin-top:4px;">电话: 010-62987887</h5>
            <h5 style="margin-bottom:4px;">合肥实验室：合肥市高新区创新产业园二期G2 A座1F</h5>
            <h5 style="margin-top:4px;">电话: 0551-65310036</h5>
            <h5 style="margin-bottom:4px;">成都实验室：四川省成都市高新区天府大道北段1480号高新孵化园5号楼111室</h5>
            <h5 style="margin-top:4px;">电话: 028-87099007</h5>
            <h5>深圳实验室：深圳市宝安区新安街道兴东社区67区大仟工业厂区2号厂房1层03</h5>
            <h5 style="margin-top:4px;">电话: 0755-86955112</h5>
            <!-- <h5>备案号：皖ICP备17004697号 <img :src='require("./assets/icp.png")'/> 公安备案：34010302001037</h5> -->
            <!-- <el-row class="footPc">
              <el-col :span="8">
                <img :src="qrcode" alt class="pc" />
              </el-col>
              <el-col :span="8">
                <h5 v-for="(item,index) in routeList1" :key="item.title">
                  <router-link
                    :to="getRountName(item.path,item.value)"
                    :data-type="index+1"
                  >{{item.title}}</router-link>
                </h5>
              </el-col>
              <el-col :span="8">
                <h5 v-for="(item,index) in routeList2" :key="item.title">
                  <router-link
                    :to="getRountName(item.path,item.value)"
                    :data-type="index+5"
                  >{{item.title}}</router-link>
                </h5>
              </el-col>
            </el-row>
            <h5>综合管理部：hr@fibtek.com.cn &nbsp;市场部：service_jit@fibtek.com.cn</h5> -->
          </el-col>
          <el-col :span="12" style="height:100%;">
            <el-row class="footPc">
              <el-col :span="8">
                <img :src="qrcode" alt class="pc" />
              </el-col>
              <el-col :span="8">
                <h5 v-for="(item,index) in routeList1" :key="item.title">
                  <router-link
                    :to="getRountName(item.path,item.value)"
                    :data-type="index+1"
                  >{{item.title}}</router-link>
                </h5>
              </el-col>
              <el-col :span="8">
                <h5 v-for="(item,index) in routeList2" :key="item.title">
                  <router-link
                    :to="getRountName(item.path,item.value)"
                    :data-type="index+5"
                  >{{item.title}}</router-link>
                </h5>
              </el-col>
            </el-row>
            <h5>综合管理部：hr@fibtek.com.cn &nbsp;市场部：service_jit@fibtek.com.cn</h5>
            <h5>备案号：<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备18043845号</a> 
            <img :src='require("./assets/icp.png")'/> 公安备案：31011502404421
            </h5>
            <!-- <div class="bg" style="background:#f1f1f1; display:none;">
              <div class="content">
                <img :src="require('./assets/map.png')" alt />
                <div class="one">
                  <p>合肥</p>
                  <span></span>
                </div>
                <div class="two">
                  <p>上海</p>
                  <span></span>
                </div>
                <div class="three">
                  <p>北京</p>
                  <span></span>
                </div>
                <div class="four">
                  <p>成都</p>
                  <span></span>
                </div>
                <div class="five">
                  <p>深圳</p>
                  <span></span>
                </div>
              </div>
            </div> -->
          </el-col>
        </el-row>
      </div>
      <div class="mobileFoot">
        <div class="topMap" style="display:none;">
          <img :src="require('./assets/map.png')" alt />
          <div class="one">
            <p>合肥</p>
            <span></span>
          </div>
          <div class="two">
            <p>上海</p>
            <span></span>
          </div>
          <div class="three">
            <p>北京</p>
            <span></span>
          </div>
          <div class="four">
            <p>成都</p>
            <span></span>
          </div>
          <div class="five">
           <p>深圳</p>
            <span></span>
          </div>                
        </div>
        <div class="m_address">
            <div style="padding-left:15px;font-size:14px;">总部</div>
            <div><span><img :src='require("./assets/position.png")' alt=""></span>上海浦东实验室：上海市浦东新区张东路1388号2号楼</div>
            <div class="tel">电话: 021-58372276</div>
            <div>
              <span><img :src='require("./assets/position.png")' alt=""></span>
              <p>上海浦西实验室：上海市徐汇区钦江路333号钦江园37号楼1F</p>
            </div>
            <div class="tel">电话: 021-54661507</div>
            <div><span><img :src='require("./assets/position.png")' alt=""></span>北京实验室：北京市海淀区上地七街国际创业园金远见大厦一楼</div>
            <div class="tel">电话: 010-62987887</div>
            <div><span><img :src='require("./assets/position.png")' alt=""></span>合肥实验室：合肥市高新区创新产业园二期G2 A座1F</div>
            <div class="tel">电话: 0551-65310036</div>
            <div><span><img :src='require("./assets/position.png")' alt=""></span>成都实验室：四川省成都市高新区天府大道北段1480号高新孵化园5号楼111室</div>
            <div class="tel">电话: 028-87099007</div>
            <div><span><img :src='require("./assets/position.png")' alt=""></span>深圳实验室：深圳市宝安区新安街道兴东社区67区大仟工业厂区2号厂房1层03</div>
            <div class="tel">电话: 0755-86955112</div>
            <!-- <div class="bei">备案号：皖ICP备17004697号</div>
            <div class="icp"><img :src='require("./assets/icp.png")'/> 公安备案：34010302001037</div> -->
        </div>
         <div class="m_code">
          <img :src="qrcode" alt/>
        </div>
         <div>
           <div style="font-size:12px;margin-top:10px;">综合管理部：hr@fibtek.com.cn</div>
           <div style="font-size:12px;">市场部：service_jit@fibtek.com.cn</div>
           <div style="font-size:12px;" class="bei">备案号：<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备18043845号</a></div>
          <div style="font-size:12px;" class="icp"><img :src='require("./assets/icp.png")'/> 公安备案：31011502404421</div>
         </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { getCompany, getNavTitle } from "./api/allApiRequest.js";
export default {
  name: "App",
  data() {
    return {
      activeIndex: "1",
      ulDisable: true,
      titleNav: "首页",
      obj: "",
      qrcode: "",
      logosrc: "",
      routeList: [
        { path: "/", value: "0", title: "首页" },
        { path: "/LaboratoryServices", value: "0", children:[],title: "实验室服务项目" },
        // { path: "/business", value: "0",children:[], title: "竞争力分析" },
        { path: "/construction", value: "0",children:[], title: "实验室建设" },
        { path: "/sale", value: "0", children:[],title: "设备销售" },
        { path: "/spareParts", value: "0",children:[], title: "维保支援" },
        { path: "/news", value: "02", title: "新闻动态" },
        { path: "/about", value: "01", title: "关于我们",children:[{title:'公司介绍',id:1},{title:'历史进程',id:2}] }
      ],
      routeList1: [],
      routeList2: [],
      routeList3:[],
      type:'1',
      showLi:false,
      mobileActiveName: '0'
    };
  },
  mounted() {
   setInterval(()=>{
      this.activeIndex = sessionStorage.getItem("activeIndex");
   },500) 
    this.getCompanyList();
    this.getRountsList();
    this.titleNav = this.routeList[(sessionStorage.getItem('activeIndex')+'').split('-')[0]-1].title
  },
  methods: {
    getActiveIndex(e) {
      this.titleNav = this.routeList[e.target.dataset.type-1].title
      sessionStorage.setItem("activeIndex", e.target.dataset.type);
      this.activeIndex = sessionStorage.getItem("activeIndex");
    },
    iconClick(e) {
      this.ulDisable = !this.ulDisable;
    },
    indexChange(e) {
      clearTimeout(this.obj);
      sessionStorage.setItem("activeIndex", e.target.dataset.type);
      this.activeIndex = e.target.dataset.type;
      this.titleNav = e.target.dataset.title;
      this.obj = setTimeout(() => {
        this.ulDisable = true;
      }, 500);
    },
    //公司信息返显
    getCompanyList() {
      getCompany().then(res => {
        this.qrcode = process.env.VUE_APP_WEB_URL + res.data.qrCode;
        this.logosrc = process.env.VUE_APP_WEB_URL + res.data.logo;
      });
    },
    //动态导航栏
    getRountsList() {
      getNavTitle().then(res => {
        res.data.forEach(item => {
          this.routeList.forEach(a => {
            if (item.title == a.title) {
              a.value = item.id;
              a.children = item.children
            }
          });
          sessionStorage.setItem('value',this.routeList[1].value)
        });
        for (let i = 0; i <= 3; i++) {
          this.routeList1.push(this.routeList[i]);
        }
        // 7
        for (let i = 4; i <= 6; i++) {
          this.routeList2.push(this.routeList[i]);
        }
        for(let i = 1; i <= 5; i++){
          this.routeList3.push(this.routeList[i])
        }
      });
    },
    //路径拼接
    getRountName(a, b) {
      return a + "?value=" + b + '&id=1';
    },
     getRountNamePc(a, b) {
      return a + "?value=" + b ;
    },
    handleSelect(e) {
      this.activeIndex = e;
      e = e + ''
      sessionStorage.setItem("activeIndex", e);
      this.type = e.split('-')[1]
      if(this.type){
        sessionStorage.setItem('type',this.type)
      }else{
        sessionStorage.setItem('type',1)
      }
    },
    isShowLi(){
      this.showLi = !this.showLi
    },
    // 没有展开的事件
    mobileGoPage(item){
      this.$router.push(item.path + '?value=' + item.value + '&id=0')
      this.ulDisable = !this.ulDisable;
      this.titleNav = item.title;
      sessionStorage.setItem('type',100)
    },
    // 有展开的事件
    childrenGopage(item,item2,index){
      this.$router.push(item.path + '?value=' + item.value + '&id=' + item2.id)
      this.ulDisable = !this.ulDisable;
      this.titleNav = item.title;
      sessionStorage.setItem('type',100);
      sessionStorage.setItem('mobileActiveName',index)
    }
  },
  created(){
    this.mobileActiveName = sessionStorage['mobileActiveName']
  }
};
</script>


<style>
#app{
  margin-top:80px;
  box-sizing: border-box;
}
.navPcParent{
  width:100%;
  height: 80px;
  position: fixed;
  top: 0;
  z-index: 20000;
  background: #fff;
  box-shadow: 1px 1px 1px 1px #e4e4e4;
  border-top:6px solid #235e9d;
}
.navRight{
  margin-left:2%!important;
}
img{
   object-fit: cover;
}
html,body{
    font-family:"Microsoft YaHei", "微软雅黑", Arial, Helvetica, sans-serif;
}
/* .el-menu--horizontal > .el-menu-item:hover {
  color: #fff !important;
} */
.el-collapse-item__header {
  /* color: #235e9d !important; */
  padding-left: 20px;
  line-height: 24px !important;
}
.el-collapse-item__content div{
  padding-left: 23px !important;
}
#collapseActive{
  color: #235e9d !important;
}
.el-collapse-item__content {
  padding-bottom: 0px;
}
#contentTitle .is-active {
  background-color: #235e9d;
  color: #fff !important;
}
#nav .is-active {
  background-color: #a4d0fd;
  color: rgb(5, 59, 123) !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: rgba(7, 7, 7, 0.8);
}
.el-collapse-item__content {
  padding-bottom: 0px;
}
.el-menu-demo{
  display:flex;
  justify-content: space-between;
  height: 80px;
}
.el-menu-demo li {
  width: 15.5%;
  padding:0 2%;
  text-align: center;
}
.el-menu-demo li:nth-child(2){
  width:18%;
}
.el-menu--horizontal>.el-menu-item,.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 67px;
  line-height: 70px;
}
.el-menu--horizontal>.el-submenu .el-submenu__title{
  color: #333 !important;
  font-size: 16px;
}
.el-menu li{
  color:#fff!important;
}
.el-menu li.rubberBand{
  color: #333 !important;
  font-size: 16px;
}
.el-menu-item {
  background-color: transparent !important;
  color: rgb(119,119,119);
}
.el-menu {
  background: transparent;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
 
  background-color: transparent !important;
}
.el-menu.el-menu--horizontal {
  border: 0;
}
.newsBack {
  background-color: rgba(7, 7, 7, 0.8)!important;
}
.newsBack:hover {
  color: #67acff !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom:5px solid #409EFF;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border-bottom:5px solid #409EFF;
}
.el-icon-arrow-down{
  display:none;
}
</style>


<style scoped>
.footMargin{
  padding:30px 0;
  /* background:url(./assets/footerBg.png) no-repeat center;
  background-size:cover; */
  background-color: #053b7b;
}
a {
  text-decoration: none;
  color: #fff;
}
.footPc {
  padding: 10px;
}
.footers {
  display: flex;
  align-items: center;
}
.el-submenu__title {
  width: 12%;
  color: #000;
  text-align: center;
  font-size: 16px;
}

.el-submenu__title {
  border: 0px !important;
}
.foot {
  margin: 0 auto;
  width: 1190px;
  /* background-color: #053b7b; */
}
h5 {
  margin: 8px;
  color: #fff;
  font-weight: 500;
}

* {
  padding: 0px;
  margin: 0px;
}
/* 底部地图 */
.bg {
  width: 95%;
  height: 100%;
  position: relative;
}
.bg img {
  width: 95%;
  height: 418px;
  object-fit: contain;
}
.bg .content {
  width: 95%;
  height: 418px;
  position: absolute;
}
.bg .content div ,.topMap div{
  background: #eb9651;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
}
.bg .content p ,.topMap p{
  position: absolute;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  animation: myfirst 4s infinite;
  border: 1px solid #eb9651;
  opacity: 0;
}
.bg .content span,.topMap span {
  position: absolute;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  animation: myfirst 4s infinite;
  border: 1px solid #eb9651;
  opacity: 0;
}
.bg .content .one ,.topMap .one{
  position: absolute;
  left: 75%;
  top: 59%;
}
.bg .content .two,.topMap .two {
  position: absolute;
  left: 83%;
  top: 57%;
}
.bg .content .three ,.topMap .three{
  position: absolute;
  left: 71%;
  top: 38%;
}
.bg .content .four ,.topMap .four{
  position: absolute;
  left: 50%;
  top: 63%;
}
.bg .content .five ,.topMap .five{
  position: absolute;
  left: 71%;
  top: 81%;
}
.bg .content .one span,.topMap .one span {
  animation-delay: 5s;
}
.bg .content .two span,.topMap .two span {
  animation-delay: 5s;
}
.bg .content .three span,.topMap .three span {
  animation-delay: 5s;
}
.bg .content .four span ,.topMap .four span{
  animation-delay: 5s;
}
.bg .content .five span ,.topMap .five span{
  animation-delay: 5s;
}
/* 旋转 */
.body{
    height: 80px;
    width: 100%;
    perspective: 800px;
    perspective-origin: center;
    transform-style: preserve-3d;
}
.father{
    width: 100%;
    height: 80px;
    transform:rotateX(0deg);
    transform-style: preserve-3d;
    perspective-origin: center;
    animation: rotate 20s infinite linear;
}
.father>div{
    width: 100%;
    height: 80px;
    position: absolute;
    background-color: #fff;
}
.father>div>div{
  height: 80px;
  font-size: 24px;
  line-height: 80px;
  font-weight: 600;
  color: #fff;
  text-shadow:-1px 0 black,
                0 1px black,
                1px 0 black,
                0 -1px black;
}
/* 正 */
.son1{
    transform: translateZ(30px);
}
/* 背 */
.son3{
    transform: rotateX(180deg) translateZ(30px) ;
}
/* 上 */
.son5{
    transform: rotateX(90deg) translateZ(30px);
}
/* 下 */
.son6{
    transform: rotateX(-90deg) translateZ(30px);
}
@keyframes rotate {
   0%{
     transform: rotateX(0deg);
   }
   5%{
     transform: rotateX(90deg);
   }
   25%{
      transform: rotateX(90deg);
   }
   30%{
     transform: rotateX(180deg);
   }
   50%{
     transform: rotateX(180deg);
   }
   55%{
      transform: rotateX(270deg);
   }
   75%{
     transform: rotateX(270deg);
   }
   80%{
     transform: rotateX(360deg);
   }
   100%{
     transform: rotateX(360deg);
   }
}

@keyframes myfirst {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.pc {
  height: 100px;
  margin-top:6px;
}
.navPc {
  margin:0 auto;
  width:1190px;
  height:80px;
}
.navMobile {
  display: none;
}
.mobileFoot{
  display:none;
  position: relative;
}
@media screen and (max-width: 750px) {
  #app{
    margin-top:0px;
  }
  .footMargin{
    padding: 20px 10px;
  }
  .footMargin .foot{
    display:none;
  }
  .footPc {
    padding: 0px;
  }
  .navPc ,.navPcParent{
    display: none !important;
  }
  .foot {
    margin: 15px 0 0 0px;
    width: 100%;
  }
  h5 {
    margin: 3px;
    font-size: 6px;
  }
  .pc {
    height: 50px;
    margin-top: 5px;
  }
  .bg img {
    width: 100%;
    height: 150px;
  }
  .bg .content {
    height: 208px;
    margin-top: 61%;
  }
  .navMobile,
  .navMobile li,
  .navMobile div {
    display: block;
    min-height: 50px;
    line-height: 50px;
    text-align: center;
    position: relative;
  }
  .topTitle{
    border-bottom:1px solid #D8D9DA;
  }
  .navList {
    position: relative;
    z-index: 10001;
    /* background-color: rgb(5, 59, 123); */
    color: #666;
    background-color:#fff;
    transition: all 2s;
    padding:0 0.2rem;
  }
  .navList li{
    text-align:left;
    border-bottom: 1px solid #D8D9DA;
    min-height: 50px;
    line-height: 50px;
    padding:0 0.2rem;
  }
  .navList li a{
     color: #666;
  }
  .navList li.firstLi{
    /* background:url(./assets/circle.png) no-repeat right; */
    position: relative;
  }
  .navList li.firstLi .imgIcon{
    position: absolute;
    top:0;right:0.2rem;
  }
  .childrenList li{
    border-bottom:0;
    font-size:14px;
  }
  .bg .content .three {
    left: 70%;
    top: 26%;
  }
  .bg .content .one {
    left: 75%;
    top: 42%;
  }
  .bg .content .two {
    left: 83%;
    top: 40%;
  }
  .bg .content .four {
    left: 48%;
    top: 42%;
  }
  .bg .content .five {
    left: 69%;
    top: 55%;
  }
  .bg .content p {
    margin-left: -20px;
    margin-top: -20px;
    width: 40px;
    height: 40px;
  }
  .bg .content span {
    margin-left: -20px;
    margin-top: -20px;
    width: 40px;
    height: 40px;
  }
  .mobileFoot{
    width:100%;
    height: 100%;
    display: block;
    color:#fff;
  }
  .topMap{
    height: 150px;
    width:100%;
    position: relative;
  }
  .topMap img{
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  .m_code{
    font-size:13px;
    width: 90%;
    margin:15px auto 0;
  }
  .m_code img{
    height: 80px;
    display:block;
    margin:0 auto;
  }
  .m_address{
    font-size: 12px;
    /* width: 90%; */
    margin:10px auto 0;
    line-height: 20px;
  }
  .bei {
    margin-top:5px ;
  }
  .icp{
    display: flex;
    align-items: center;
    /* margin-top:5px; */
  }
  .icp img{
    display: inline-block;
    margin-right:5px;
  }
  .topMap .one{
    left: 66%;
    top: 59%;
  }
  .topMap .two {
    left: 70%;
    top: 57%;
  }
  .topMap .three{
    left: 63%;
    top: 38%;
  }
  .topMap .four{
    left: 50%;
    top: 63%;
  }
  .topMap .five{
    left: 62%;
    top: 84%;
  }
  .topMap div{
    width: 5px;
    height: 5px;
  }
  .topMap p,.topMap span{
    margin-left: -25px;
    margin-top: -25px;
    width: 50px;
    height: 50px;
    top: 25%;
    left: 25%;
  }
  .m_address>div>span{
    display: inline-block;
    height: 13px;
    width:13px;
  }
  .m_address>div{
    display: flex;
    align-items: center;
  }
  .m_address>div>span img{
   height:100%;
  }
  .m_address .tel{
    padding-left:15px;
    margin-bottom: 10px;
  }
  .m_address .bei{
    margin-top: 10px;
  }
  .newNavList .el-collapse-item__content div{
    text-align: left;
    padding-left:34px!important;
  }
  .newNavList >>>.el-collapse-item__header{
    font-size:15px!important;
  }
  .newNavList >>>.el-collapse-item.is-disabled .el-collapse-item__header{
    color:#303133!important;
  }
}
</style>
